var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isAppClassic())?_c('iframe',{attrs:{"src":"https://numer.ai/_auth/frame"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }